<template>
  <v-dialog
    v-model="confirmModalData.isOpen"
    class="confirm-dialog"
    style="max-width: 460px"
    persistent
  >
    <v-card
      class="confirm-dialog-window"
      :class="{ 'is-native': confirmModalData.isNative }"
    >
      <v-card-text>
        <p
          v-if="confirmModalData.title"
          v-text="confirmModalData.title"
          class="text-subtitle-1 mt-2"
        />
        <p
          v-if="confirmModalData.text"
          v-text="confirmModalData.text"
          class="text-body-2 mt-2"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="action-btn"
          size="large"
          :variant="confirmModalData.isNative ? 'text' : 'flat'"
          @click="confirmModalData.reject?.()"
        >
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
          class="action-btn"
          size="large"
          :color="confirmModalData.isNative ? undefined : 'primary'"
          :variant="confirmModalData.isNative ? 'text' : 'flat'"
          @click="confirmModalData.confirm?.()"
        >
          {{ $t("common.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useModals } from "@/stores";
import { storeToRefs } from "pinia";

const { confirmModalData } = storeToRefs(useModals());
</script>

<style lang="scss">
.confirm-dialog {
  .confirm-dialog-window {
    // Makes the modal too look similar to native system. At least on IOS systems.
    &.is-native {
      --v-theme-surface: 255, 255, 255;

      p {
        font-family: system-ui, sans-serif !important;
        color: black;
      }

      .action-btn {
        font-family: system-ui, sans-serif !important;
        font-weight: bold;
        font-size: 14px !important;
        letter-spacing: 0 !important;
        color: #007aff;
      }
    }
  }
}
</style>
